import React from "react";
import "./DealerUploadFFL.css";

const FFLUploadPanel = ({
    file,
    filePreviewUrl,
    handleDroppedFFL,
    openPhotoModal,
    validationErrors,
    fflFileRef,
    fflDropInputRenewRef,
    status,
    claimId,
}) => {

    return (
        <div className="form-section" ref={fflFileRef}>
            <small className="note">
                <span className="required">**</span> Upload a copy of your FFL (PDF, PNG, or JPEG)
            </small>

            <div className="file-upload-container">
                <button
                    type="button"
                    className={`custom-file-upload ${validationErrors.fflUpload ? "input-error" : ""}`}
                    onClick={() => fflDropInputRenewRef.current?.click()}
                >
                    {file ? "Update File" : "Upload File"}
                </button>

                {file ? (
                    <span
                        className="file-name clickable"
                        onClick={() =>
                            openPhotoModal(
                                filePreviewUrl,
                                file.type === "application/pdf" ? "pdf" : "image"
                            )
                        }
                    >
                        {file.name}
                    </span>
                ) : (
                    <span className="file-name">No file selected.</span>
                )}
            </div>

            <input
                type="file"
                ref={fflDropInputRenewRef}
                style={{ display: "none" }}
                accept=".pdf, image/jpeg, image/png"
                onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) handleDroppedFFL(file, claimId);
                }}
            />
        </div>
    );
};

export default FFLUploadPanel;